import { render, staticRenderFns } from "./StudioProductContent.vue?vue&type=template&id=22055a9b&scoped=true&"
import script from "./StudioProductContent.vue?vue&type=script&lang=js&"
export * from "./StudioProductContent.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductContent.vue?vue&type=style&index=0&id=22055a9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22055a9b",
  null
  
)

export default component.exports